export default __webpack_public_path__ + "static/sknb-cd5294fdb0fb192a890f280f05354877.png";